package com.havn.app.features.analytics.data

import kotlinx.browser.window

private const val AnalyticsAiInsightsPrefix = "havn.analyticsAi."

actual fun loadStoredAnalyticsAiInsights(cacheKey: String): String? =
    window.localStorage.getItem(AnalyticsAiInsightsPrefix + cacheKey)?.takeIf { it.isNotBlank() }

actual fun storeAnalyticsAiInsights(cacheKey: String, json: String) {
    window.localStorage.setItem(AnalyticsAiInsightsPrefix + cacheKey, json)
}
